import React, { useState, useEffect } from "react";
import axios from "axios";
import "./design/List.css";
import { Card, Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan, faUserPlus, faCirclePlus, faSortUp, faSortDown, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import CrearCurso from "./CrearCurso";
import EditarCurso from "./EditarCurso";
import { RoleGate } from "./middleware/RoleGate.jsx";

function Cursos() {
    const [cursos, setCursos] = useState([]);
    const [expandedCurso, setExpandedCurso] = useState(null);
    const [tipoCursoOptions, setTipoCursoOptions] = useState([]);
    // const [statusOptions, setStatusOptions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showInscribirModal, setShowInscribirModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [cursoIdToEdit, setCursoIdToEdit] = useState(null);
    const [cursoIdToDelete, setCursoIdToDelete] = useState(null);
    // const [sociosList, setSociosList] = useState([]);
    const [selectedCursoId, setSelectedCursoId] = useState(null);
    const [nSocioInput, setNSocioInput] = useState("");
    const [socioEncontrado, setSocioEncontrado] = useState(null);
    const [errorSocio, setErrorSocio] = useState("");
    const [busqueda, setBusqueda] = useState("");
    const [tipoFiltro, setTipoFiltro] = useState("todos");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [expandedSocios, setExpandedSocios] = useState(null);
    const [sociosCurso, setSociosCurso] = useState([]);



    useEffect(() => {
        fetchCursos();
        fetchOptions();
    }, []);

    const fetchCursos = async () => {
        try {
            const response = await axios.get("http://192.168.1.81:5000/backend/api/cursos");
            setCursos(response.data);
        } catch (error) {
            console.error("Error al obtener cursos", error);
        }
    };

    // Sets the available options for course type and status dropdowns.
    const fetchOptions = () => {
        setTipoCursoOptions([
            { id: "Introducción", nombre: "Introducción" },
            { id: "Taller", nombre: "Taller" },
            { id: "Capacitación", nombre: "Capacitación" }
        ]);
    };


    const toggleExpand = (id) => {
        setExpandedCurso(expandedCurso === id ? null : id);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete("http://192.168.1.81:5000/backend/api/cursos", { data: { id } });
            fetchCursos();
        } catch (error) {
            console.error("Error al eliminar curso:", error.response?.data || error.message);
        }
    };

    const openEditModal = (id) => {
        setCursoIdToEdit(id);
        setShowEditModal(true);
    };

    const openDeleteModal = (id) => {
        setCursoIdToDelete(id);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (cursoIdToDelete) {
            await handleDelete(cursoIdToDelete);
            setShowDeleteModal(false);
            setCursoIdToDelete(null);
        }
    };

    const formatDate = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        return date.toLocaleDateString("es-CL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const abrirInscribirModal = async (cursoId) => {
        setSelectedCursoId(cursoId);
        try {
            // const res = await axios.get("http://192.168.1.81:5000/backend/api/socios");
            // setSociosList(res.data);
            setShowInscribirModal(true);
        } catch (error) {
            console.error("Error al obtener socios:", error);
        }
    };

    // Buscar socio por número
    const buscarSocio = async () => {
        if (!nSocioInput.trim()) {
            setSocioEncontrado(null);
            setErrorSocio("Por favor ingrese un número de socio.");
            return;
        }
        try {
            const res = await axios.get(`http://192.168.1.81:5000/backend/api/socios/buscar/${nSocioInput}`);

            // Si el backend devuelve 404, se captura en el catch
            if (!res.data || Object.keys(res.data).length === 0) {
                setSocioEncontrado(null);
                setErrorSocio("Socio no encontrado");
                return;
            }

            setSocioEncontrado(res.data[0]);
            setErrorSocio("");
        } catch (err) {
            console.error("Error al buscar socio:", err);
            setSocioEncontrado(null);
            setErrorSocio("Socio no encontrado");
        }
    };

    const toggleSociosCurso = async (cursoId) => {
        if (expandedSocios === cursoId) {
            setExpandedSocios(null); // Cierra si está abierto
        } else {
            setExpandedSocios(cursoId); // Abre el curso seleccionado
            if (!sociosCurso[cursoId]) {
                try {
                    const res = await axios.get(`http://192.168.1.81:5000/backend/api/inscripciones/curso/${cursoId}`);
                    setSociosCurso((prev) => ({
                        ...prev,
                        [cursoId]: res.data
                    }));
                    console.log("Socios del curso cargados:", res.data);

                } catch (err) {
                    console.error("Error al cargar socios del curso", err);
                }
            }
        }
    };

    useEffect(() => {
        if (expandedCurso !== null) {
            toggleSociosCurso(expandedCurso);
        }
    }, [expandedCurso, sociosCurso]);


    // Guardar inscripción
    const guardarInscripcion = async () => {
        try {
            // Verificar si el socio ya está inscrito en este curso
            const inscritos = sociosCurso[selectedCursoId] || [];
            const yaInscrito = inscritos.some(s => s.n_socio === socioEncontrado.n_socio);

            if (yaInscrito) {
                setErrorSocio(`El socio ${socioEncontrado.n_socio} ya está inscrito en este curso.`);
                return;
            }

            await axios.post("http://192.168.1.81:5000/backend/api/inscripciones", {
                socio_id: socioEncontrado.n_socio,
                curso_id: selectedCursoId
            });

            setShowInscribirModal(false);
            setSocioEncontrado(null);
            setNSocioInput("");
            setErrorSocio("");
            setSociosCurso(prev => {
                const updated = { ...prev };
                delete updated[selectedCursoId];
                return updated;
            });
            setTimeout(() => {
                if (expandedCurso === selectedCursoId) {
                    toggleSociosCurso(selectedCursoId);
                }
            }, 0);
        } catch (error) {
            console.error("Error al inscribir socio:", error);
            setErrorSocio("No se pudo inscribir al socio. Intente nuevamente.");
        }
    };

    const cursosFiltrados = cursos.filter(c => {
        const coincideBusqueda = `${c.nombre} ${c.encargado}`.toLowerCase().includes(busqueda.toLowerCase());
        const coincideTipo = tipoFiltro === "todos" || c.tipo_curso === tipoFiltro;
        return coincideBusqueda && coincideTipo;
    });

    const totalPages = Math.ceil(cursosFiltrados.length / rowsPerPage);
    const cursosPaginados = cursosFiltrados.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

    const getVisiblePageNumbers = () => {
        const totalPages = Math.ceil(cursosFiltrados.length / rowsPerPage);
        const visiblePages = [];
        const maxVisiblePages = 5;

        let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
        let endPage = startPage + maxVisiblePages - 1;

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(endPage - maxVisiblePages + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            visiblePages.push(i);
        }

        return visiblePages;
    };
    const indexOfLastCurso = currentPage * rowsPerPage;
    const indexOfFirstCurso = indexOfLastCurso - rowsPerPage;
    const totalCursos = cursosFiltrados;

    const handleClose = () => { setShowModal(false); fetchCursos(); };
    const handleEditClose = () => { setShowEditModal(false); setCursoIdToEdit(null); fetchCursos(); };

    const handleEliminarInscripcion = async (n_socio, curso_id) => {
        if (!window.confirm('¿Está seguro que desea eliminar esta inscripción?')) {
            return;
        }
        
        try {
            console.log("Eliminando inscripción de socio:", n_socio, "del curso:", curso_id);
            await axios.delete(`http://192.168.1.81:5000/backend/api/inscripciones/${curso_id}/${n_socio}`);
            setSociosCurso(prev => {
                const updated = { ...prev };
                if (updated[curso_id]) {
                    updated[curso_id] = updated[curso_id].filter(s => s.n_socio !== n_socio);
                }
                return updated;
            });
        } catch (error) {       
            console.error("Error al eliminar inscripción:", error);
        }
    };

    const exportarExcel = () => {
        const datos = cursosFiltrados.map(c => ({
            TipoCurso: c.tipo,
            Nombre: c.nombre,
            Encargado: c.encargado,
            Estado: c.status
        }));
        const ws = XLSX.utils.json_to_sheet(datos);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Cursos");
        XLSX.writeFile(wb, "cursos.xlsx");
    };

    const exportarPDF = async () => {
        const input = document.getElementById("tabla-cursos");
        const canvas = await html2canvas(input);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("socios-contabilidad.pdf");
    };

    return (
        <div className="container">
            <div className="container mt-4">

                {/* Modal para agregar curso */}
                <Modal show={showModal} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <CrearCurso onSuccess={handleClose} />
                    </Modal.Body>
                </Modal>

                <Modal show={showEditModal} onHide={handleEditClose} centered>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <EditarCurso id={cursoIdToEdit} onClose={handleEditClose} />
                    </Modal.Body>
                </Modal>

                {/* Modal para inscribir socio */}
                {showInscribirModal && (
                    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Inscribir Socio</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowInscribirModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <label>Número de Socio:</label>
                                    <input
                                        type="text"
                                        className="form-control mb-2"
                                        value={nSocioInput}
                                        onChange={(e) => setNSocioInput(e.target.value)}
                                    />
                                    <button className="btn btn-secondary mb-3" onClick={buscarSocio}>Buscar</button>

                                    {errorSocio && <div className="text-danger">{errorSocio}</div>}

                                    {socioEncontrado && (
                                        <div className="alert alert-success">
                                            <strong>Número de Socio:</strong> {socioEncontrado.n_socio} <br />
                                            <strong>Nombre:</strong> {socioEncontrado.nombre} {socioEncontrado.apellido} <br />
                                            <strong>RUT:</strong> {socioEncontrado.rut}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowInscribirModal(false)}>Cancelar</button>
                                    <button
                                        className="btn btn-primary"
                                        disabled={!socioEncontrado}
                                        onClick={guardarInscripcion}
                                    >
                                        Inscribir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal para confirmar eliminación */}
                {showDeleteModal && (
                    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Confirmar Eliminación</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <p>¿Estás seguro de que deseas eliminar este curso?</p>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</button>
                                    <button className="btn btn-danger" onClick={confirmDelete}>Eliminar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Card className="shadow p-3">
                    <Card.Body>
                        <h3 className="mt-4">Lista de Cursos</h3>

                        <RoleGate allowedRoles={["Administrador", "Digitador"]}>
                            <button className="btn mb-3" onClick={() => setShowModal(true)}>
                                <FontAwesomeIcon icon={faCirclePlus} size="2x" />
                                <div>Nuevo Curso</div>
                            </button>
                        </RoleGate>
                        <div className="row mb-4">
                            <div className="col-md-5 mb-2">
                                <TextField label="Buscar por nombre del curso o encargado" fullWidth value={busqueda} onChange={e => setBusqueda(e.target.value)} size="small" />
                            </div>
                            <div className="col-md-5 mb-2">
                                <select className="form-control" value={tipoFiltro} onChange={e => setTipoFiltro(e.target.value)}>
                                    <option value="todos">Todos los tipos</option>
                                    {tipoCursoOptions.map(t => (
                                        <option key={t.id} value={t.id}>{t.id}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-1 mb-2 gap-2 d-flex">
                                <Button className="btn btn-success btn-sm " onClick={exportarExcel}><FontAwesomeIcon icon={faFileExcel} size="xl" /></Button>

                                <Button className="btn btn-danger btn-sm " onClick={exportarPDF}><FontAwesomeIcon icon={faFilePdf} size="xl" /></Button>
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="mr-2 fw-medium">N° de filas: </label>
                            <select
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(parseInt(e.target.value));
                                    setCurrentPage(1);
                                }}
                                className="border rounded px-2 py-1"
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>
                        <p className="text-center text-muted">
                            Mostrando {indexOfFirstCurso + 1}–{Math.min(indexOfLastCurso, totalCursos.length)} de {totalCursos.length} Cursos
                        </p>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>Tipo de Curso</th>
                                        <th>Nombre</th>
                                        <th>Encargado</th>
                                        <th>Estado</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cursosPaginados.map((c) => (
                                        <React.Fragment key={c.id}>
                                            <tr>
                                                <td>{c.tipo_curso.toUpperCase()}</td>
                                                <td>{c.nombre}</td>
                                                <td>{c.encargado}</td>
                                                <td>
                                                    <span className={`badge bg-${c.status === "Activo" ? "success" : c.status === "Finalizado" ? "danger" : c.status === "Suspendido" ? "warning" : "secondary"}`}>
                                                        {c.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <RoleGate allowedRoles={["Administrador"]}>
                                                        <button className="btn btn-sm me-2" title="Editar" onClick={() => openEditModal(c.id)}>
                                                            <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                                                        </button>
                                                        <button className="btn btn-sm me-2" title="Eliminar" onClick={() => openDeleteModal(c.id)}>
                                                            <FontAwesomeIcon icon={faTrashCan} size="lg" />
                                                        </button>
                                                        </RoleGate>
                                                        <RoleGate allowedRoles={["Administrador", "Digitador"]}>
                                                        <button className="btn btn-sm me-2" title="Inscribir Socios" onClick={() => abrirInscribirModal(c.id)}>
                                                            <FontAwesomeIcon icon={faUserPlus} size="lg" />
                                                        </button>
                                                        </RoleGate>
                                                    
                                                    <button className="btn btn-sm" title="Más Información" onClick={() => toggleExpand(c.id)}>
                                                        {expandedCurso === c.id ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />}
                                                    </button>
                                                </td>
                                            </tr>
                                            {expandedCurso === c.id && (
                                                <tr>
                                                    <td colSpan="2">
                                                        <div className="p-2 bg-light border rounded">
                                                            <p><strong>Fecha de Inicio:</strong> {formatDate(c.fecha_inicio)}</p>
                                                            <p><strong>Fecha de Término:</strong> {formatDate(c.fecha_termino)}</p>
                                                            <p><strong>Horario:</strong> {typeof c.horario === "string" && c.horario.length >= 5 ? c.horario.slice(0, 5) : ""}</p>
                                                            <p><strong>Lugar:</strong> {c.lugar}</p>
                                                            <p><strong>Notas:</strong> {c.notas}</p>
                                                        </div>
                                                    </td>
                                                    <td colSpan="3" style={{ background: "#f9f9f9" }}>
                                                        <div style={{ padding: "10px" }}>
                                                            <h5>Socios inscritos</h5>
                                                            {sociosCurso[expandedCurso] ? (
                                                                sociosCurso[expandedCurso].length > 0 ? (
                                                                    <table className="table table-sm">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>N° Socio</th>
                                                                                <th>RUT</th>
                                                                                <th>Nombre</th>
                                                                                <RoleGate allowedRoles={["Administrador"]}><th>Acciones</th></RoleGate>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {sociosCurso[expandedCurso].map((s) => (
                                                                                <tr key={`${s.n_socio}-${s.rut}`}>
                                                                                    <td>{s.n_socio}</td>
                                                                                    <td>{s.rut}</td>
                                                                                    <td>{s.nombre} {s.apellido}</td>
                                                                                    <td>
                                                                                       <RoleGate allowedRoles={["Administrador"]}>
                                                                                         <button className="btn btn-sm btn-danger" title="Eliminar Inscripción" onClick={() => handleEliminarInscripcion(s.n_socio, expandedCurso)}>
                                                                                           <FontAwesomeIcon icon={faTrashCan} />
                                                                                         </button>
                                                                                       </RoleGate>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                ) : (
                                                                    <p>No hay socios inscritos.</p>
                                                                )
                                                            ) : (
                                                                <p>Cargando socios...</p>
                                                            )}
                                                        </div>
                                                    </td>

                                                </tr>
                                            )}

                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-center justify-content-md-end mt-3">
                            <nav>
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                            Anterior
                                        </button>
                                    </li>
                                    {getVisiblePageNumbers().map((number) => (
                                        <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(number)}>
                                                {number}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                            Siguiente
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default Cursos;
